import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Loader from "./Loader";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
    overflow: "hidden",
    position: "relative",
  },
  text: {
    color: theme.palette.text.secondary,
    zIndex: 1,
  },
}));

/**
 * @returns This component returns custom loader with tsx format in the middle of the parent element
 */
function LoaderContainer() {
  // states and handlers
  const classes = useStyles();
  // render jsx
  return (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: { xs: 0 },
      }}
      className={classes.container}
    >
      <Loader />
    </Container>
  );
}

export default LoaderContainer;
